/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { ACheckbox, AInput } from 'components/Antd';
import classes from './FilterDropdown.module.scss';

const FilterDropdownList = ({
  hasAll,
  items,
  checks,
  setChecks,
  placeholder,
  noSearch,
  isSingle,
}) => {
  const tItems = items || [];
  const tChecks = checks || [];
  const [val, setVal] = useState('');
  const filteredItems = tItems.filter((item) =>
    (item.label || '').toLowerCase().includes((val || '').toLowerCase())
  );

  return (
    <div className={classes.filterDropdownList}>
      {!noSearch && (
        <AInput
          placeholder={placeholder || 'Search'}
          prefix={
            <SearchOutlined
              style={{
                fontSize: 20,
                color: '#C4C8D0',
              }}
            />
          }
          value={val}
          onChange={(e) => setVal(e.target.value)}
        />
      )}
      <ul>
        {hasAll && (
          <li>
            <ACheckbox
              onChange={(e) => {
                setChecks(e.target.checked ? items.map((item) => item.value) : []);
              }}
              checked={tChecks.length === tItems.length}>
              All
            </ACheckbox>
          </li>
        )}
        {filteredItems.map((item, index) => {
          return (
            <li key={index}>
              <ACheckbox
                onChange={(e) => {
                  if (isSingle) {
                    setChecks(e.target.checked ? [item.value] : []);
                  } else {
                    setChecks(
                      e.target.checked
                        ? [...tChecks, item.value]
                        : tChecks.filter((v) => v !== item.value)
                    );
                  }
                }}
                checked={tChecks.includes(item.value)}>
                {item.label}
              </ACheckbox>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FilterDropdownList;
